import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo Section */}
        <div className="flex items-center space-x-3">
          <img
            src="/anilbrickss.webp"
            alt="Anil Flyash Bricks Logo"
            className="h-10 w-10 object-contain"
          />
          <h1 className="text-2xl font-extrabold text-green-700">
            Anil Flyash Bricks
          </h1>
        </div>

        {/* ✅ Desktop Menu */}
        <div className="hidden md:flex space-x-6 font-semibold items-center">
          <Link to="/" className="hover:text-green-600">
            Home
          </Link>

          {/* 🔽 Calculators Dropdown */}
          <div
            className="relative group"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button className="hover:text-green-600 flex items-center gap-1">
              Calculators <i className="fa-solid fa-chevron-down text-sm"></i>
            </button>

            {dropdownOpen && (
              <div className="absolute left-0 mt-2 w-52 bg-white shadow-lg rounded-md border border-gray-100 py-2">
                <Link
                  to="/bricks-calculator"
                  className="block px-4 py-2 hover:bg-green-50 hover:text-green-600"
                >
                  Brick Calculator
                </Link>
                <Link
                  to="/delivery-calculator"
                  className="block px-4 py-2 hover:bg-green-50 hover:text-green-600"
                >
                  Delivery Calculator
                </Link>
                <Link
                  to="/paver-calculator"
                  className="block px-4 py-2 hover:bg-green-50 hover:text-green-600"
                >
                  Paver Calculator
                </Link>
              </div>
            )}
          </div>

          <a href="#about" className="hover:text-green-600">
            About
          </a>
          <a href="#products" className="hover:text-green-600">
            Products
          </a>

          {/* ✅ Added Blog link */}
          <Link to="/blog" className="hover:text-green-600">
            Blogs
          </Link>

          <a href="#contact" className="hover:text-green-600">
            Contact
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="focus:outline-none"
          >
            <svg
              className="w-8 h-8 text-green-700"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {menuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* ✅ Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white shadow-md px-6 py-4 flex flex-col space-y-4 font-semibold">
          <Link
            to="/"
            className="hover:text-green-600"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>

          {/* 🔽 Collapsible Calculators Menu in Mobile */}
          <details className="group">
            <summary className="cursor-pointer hover:text-green-600">
              Calculators
            </summary>
            <div className="pl-4 mt-2 flex flex-col space-y-2">
              <Link
                to="/bricks-calculator"
                className="hover:text-green-600"
                onClick={() => setMenuOpen(false)}
              >
                Brick Calculator
              </Link>
              <Link
                to="/delivery-calculator"
                className="hover:text-green-600"
                onClick={() => setMenuOpen(false)}
              >
                Delivery Calculator
              </Link>
              <Link
                to="/paver-calculator"
                className="hover:text-green-600"
                onClick={() => setMenuOpen(false)}
              >
                Paver Calculator
              </Link>
            </div>
          </details>

          <a
            href="#about"
            className="hover:text-green-600"
            onClick={() => setMenuOpen(false)}
          >
            About
          </a>
          <a
            href="#products"
            className="hover:text-green-600"
            onClick={() => setMenuOpen(false)}
          >
            Products
          </a>

          {/* ✅ Blog Link for Mobile */}
          <Link
            to="/blog"
            className="hover:text-green-600"
            onClick={() => setMenuOpen(false)}
          >
            Blogs
          </Link>

          <a
            href="#contact"
            className="hover:text-green-600"
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
